import React from 'react';
import { ArrowRightIcon, DatabaseIcon } from 'lucide-react';
const internalLinks = [{
  title: 'NYC doctor database',
  description: 'Find verified local doctor and physician owner contacts in New York City.',
  href: 'https://www.openmart.com/data/doctors-new-york-city',
  count: '2,100+'
}, {
  title: 'NYC dentist database',
  description: 'Access local dentist practice owner emails and phones across NYC.',
  href: 'https://www.openmart.com/data/dentists-new-york-city',
  count: '1,800+'
}, {
  title: 'NYC lawyer database',
  description: 'Connect with local law firm partners and attorneys in New York.',
  href: 'https://www.openmart.com/data/lawyers-new-york-city',
  count: '4,500+'
}, {
  title: 'NYC restaurant database',
  description: 'Reach local restaurant owners and managers across all five boroughs.',
  href: 'https://www.openmart.com/data/restaurants-new-york-city',
  count: '8,200+'
}, {
  title: 'NYC real estate database',
  description: 'Find local real estate agents and brokers with verified NYC contacts.',
  href: 'https://www.openmart.com/data/real-estate-agents-new-york-city',
  count: '5,600+'
}, {
  title: 'NYC property management database',
  description: 'Access local property management companies across New York City.',
  href: 'https://www.openmart.com/data/property-management-new-york-city',
  count: '1,200+'
}];
export function NYCInternalLinks() {
  return <section className="py-24 bg-slate-50 border-t border-slate-100" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-209">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-210">
            Explore more{' '}
            <span className="text-blue-600" data-id="element-211">
              New York City local business databases
            </span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-212">
            Access verified local business owner contacts across multiple
            industries in the NYC metro area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-213">
          {internalLinks.map(link => <a key={link.href} href={link.href} className="group bg-white rounded-2xl p-6 border-2 border-slate-200 hover:border-blue-500 hover:shadow-lg transition-all duration-200" data-id="element-214">
              <div className="flex items-start justify-between mb-4" data-id="element-215">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors" data-id="element-216">
                  <DatabaseIcon className="w-6 h-6" data-id="element-217" />
                </div>
                {link.count && <div className="text-right" data-id="element-218">
                    <div className="text-lg font-bold text-blue-600" data-id="element-219">
                      {link.count}
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-220">contacts</div>
                  </div>}
              </div>

              <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-221">
                {link.title}
              </h3>
              <p className="text-sm text-slate-600 mb-4 leading-relaxed" data-id="element-222">
                {link.description}
              </p>

              <div className="flex items-center gap-1.5 text-sm font-semibold text-blue-600 group-hover:gap-2.5 transition-all" data-id="element-223">
                Explore database
                <ArrowRightIcon className="w-4 h-4" data-id="element-224" />
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}